import { isObjectRecord } from "../../typeGuards";
import { ArsTableCellType, ArsTableRowGroupCell } from "../interface";
import { isArsTableCellBase } from "./isArsTableCellBase";

/**
 * Type guard for ArsTableRowGroupCell, which is a possible type of ArsTableCellBase.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the cell's displayContent and annotationContent
 * @returns - True if the object is an ArsTableRowGroupCell, false otherwise
 */
export const isArsTableRowGroupCell = <T = string>(
  obj: unknown,
  isT: (value: unknown) => value is T,
): obj is ArsTableRowGroupCell<T> => {
  if (!isObjectRecord(obj)) return false;
  if (!isArsTableCellBase<T>(obj, isT)) return false;

  if (obj.cellType !== ArsTableCellType.RowGroupCell) return false;
  if (!["number", "undefined"].includes(typeof obj.colSpan)) return false;
  if (!["number", "undefined"].includes(typeof obj.indents)) return false;
  if (!["number", "undefined"].includes(typeof obj.height)) return false;
  if (!["number", "undefined"].includes(typeof obj.rowSpan)) return false;
  if (typeof obj.siblingCount !== "number") return false;
  if (typeof obj.targetId !== "string") return false;
  if (
    typeof obj.targetType !== "string" ||
    !["analysisMethod", "groupingFactor"].includes(obj.targetType)
  )
    return false;

  // Everything is good
  return true;
};
